import { FormControl } from '@angular/forms';
import { LegacyErrorStateMatcher as ErrorStateMatcher } from '@angular/material/legacy-core';

export class DirtyTouchedInvalidErrorStateMatcher<T> implements ErrorStateMatcher {
  isErrorState(control: FormControl<T> | null): boolean {
    return !!control?.invalid && (control.dirty || control.touched);
  }
}
